/**
 * 首页数据以及全局数据的 - api
 * date:2022 04 22
 * author:brian
 */

import httpRequest from '@/utils/request.js';
/** 登录接口 */
export const userLogin = (data) => httpRequest.httpPost('/service/user/login', data)
/**获取首页数据 */
export const accountInfo = (params = {}) => httpRequest.httpGet({
    url: '/service/mine/info', params: {
        ...params
    }
})
/**登出接口 */
export const userLogout = (params = {}) => httpRequest.httpGet({
    url: '/service/user/logout', params: {
        ...params
    }
})
/**代理切换接口 */
export const mineSwitch = (params = {}) => httpRequest.httpGet({
    url: '/service/mine/switch', params: {
        ...params
    }
})

/** 注册接口 */
export const userRegister = (data) => httpRequest.httpPost('/service/user/register', data)